import React from "react";

function ReservationGridEmpty(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ReservationGridEmpty;
